import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import * as _ from "lodash";

import { LoadingBarService } from "@ngx-loading-bar/core";

import { HeaderService, ServicesService } from "../../../shared";

@Component({
  selector: "app-services-list",
  templateUrl: "./services-list.component.html",
  styleUrls: ["./services-list.component.scss"]
})
export class ServicesListComponent implements OnInit {
  typeComponent = "services";

  textBtnNew = "Novo Serviço";
  urlBtnNew = "/panel/services/new";

  currentUrl = "/panel/services";

  dataList;

  pag;
  filters;
  cacheObj;

  serviceRequest;

  totalServices;

  cdOperador = localStorage.getItem("userId");

  constructor(
    private headerService: HeaderService,
    private servicesService: ServicesService,
    private loadingBarService: LoadingBarService,
    private activatedRoute: ActivatedRoute
  ) {
    if (this.activatedRoute.snapshot.params.pag) {
      this.pag = this.activatedRoute.snapshot.params.pag;
    } else {
      this.pag = 1;
    }
  }

  ngOnInit() {
    this.headerService.changeTitle("Valor por serviço");

    this.headerService.changeSubtitle("");

    this.headerService.changeDatePicker(false);

    this.dataList = {};

    this.translateFilter();
  }

  serviceList(filters = `&cdOperador=` + this.cdOperador) {
    this.loadingBarService.stop();

    this.loadingBarService.start();

    if (this.serviceRequest) {
      this.serviceRequest.unsubscribe();
    }

    this.serviceRequest = this.servicesService
      .listServices(filters)
      .subscribe(response => {
        this.loadingBarService.complete();

        this.dataList = response;

        this.totalServices = response["total"];
      });
  }

  setPag(setPag) {
    this.pag = setPag;

    this.translateFilter();
  }

  translateFilter(obj?) {
    this.filters = [];

    if (obj) {
      this.cacheObj = obj;
    }

    _.forOwn(this.cacheObj, (value, key) => {
      this.filters.push(`${key}=${value}`);
    });

    this.serviceList(
      `?pageNumber=${this.pag}&cdOperador=${this.cdOperador}${
        this.filters.length !== 0 ? "&" : ""
      }${this.filters.join("&")}`
    );
  }
}
